export enum ColdTransferType
{
    None = 0,
    Agent = 1,
    Queue = 2,
    Flow = 3,      
}